<template>
   <div class="not-available">
      <h3>{{title}}</h3>
      <div class="wrap">

        <div class="left">
          <img src="../../assets/img/common/no_data.png" alt="">
          <div class="text">
            <p style="margin-bottom: 20px;">您目前没有开通{{title}}产品，</p>
            <p>如需了解详情，联系我司销售获取产品介绍PPT、申请测试。</p>
            <p>如果还没有销售联系您，请致电400-809-3699我们为您分配。</p>
          </div>
        </div>
        <div class="doc">
           <slot></slot>
        </div>
      </div>
   </div>
</template>

<script>
export default {
  name: 'notAvailable',
  props: {
    title: { type: String, require: true }
  }
}
</script>

<style lang="scss">
.not-available{
  h3{
    font-size:18px;
    font-weight:500;
    color:rgba(29,36,60,1);
    line-height:30px;
    margin-bottom: 24px;
  }
  .wrap{
    background:rgba(255,255,255,1);
    box-shadow:0px 4px 8px 0px rgba(17,39,98,0.04);
    border-radius:4px;
    padding: 78px 64px 50px;
    .left{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      width: 586px;
      img{
        width: 134px;
        height: 147px;
      }
      .text{
        width: 410px;
        margin-left: 8px;
        p{
          font-size:14px;
          font-weight:400;
          color:rgba(29,36,60,1);
          line-height:24px;
        }
      }
    }
    .doc{
      background:rgba(225,237,255,1);
      padding: 19px 28px;
      margin-top: 45px;
      .product-introduce {
        p{
          font-size:14px;
          font-weight:400;
          color:rgba(29,36,60,1);
          line-height:22px;
          &.bottom{
            margin-bottom: 20px;
          }
          .product{
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
